import { render, staticRenderFns } from "./letter-1.vue?vue&type=template&id=dc0db326&scoped=true"
import script from "./letter-1.vue?vue&type=script&lang=js"
export * from "./letter-1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0db326",
  null
  
)

export default component.exports